import React from 'react'


import {
    getAttributeCourseStaticInfo
  } from './enrolment'

export const helpContactButtonLinkWithDescription = (text = "") => {
    let linkHref = 'https://www.vu.edu.au/course-unit-advice';
    let title = `Please contact your CUA about ${text}`

    if (getAttributeCourseStaticInfo('locationCd') === "SY") {
        linkHref = 'https://www.vu.edu.au/vu-sydney/contact-vu-sydney';
        let title = `Please contact your CC about ${text}`
    }

    return React.createElement('a', { className: 'btnBasic btn-charcoal center pd12', href: linkHref, target: '_blank', title: title }, text)
}

export const helpContactButtonLink = () => {
    let linkHref = 'https://www.vu.edu.au/course-unit-advice';
    let message =  'Contact CUA';

    if (getAttributeCourseStaticInfo('locationCd') === "SY") {
        linkHref = 'https://www.vu.edu.au/vu-sydney/contact-vu-sydney';
        message =  'Contact CC';
    }

    return React.createElement('a', { className: 'btnBasic btn-charcoal center pd12 fs12 fwBold', href: linkHref, target: '_blank' }, message)
}

export const helpLink = (locationCode = "") => {
    let linkHref = 'https://www.vu.edu.au/course-unit-advice';
    let message =  'Course and Unit Advisor (CUA)';

    if (getAttributeCourseStaticInfo('locationCd') === "SY") {
        linkHref = 'https://www.vu.edu.au/vu-sydney/contact-vu-sydney';
        message =  'Course Coordinator (CC)';
    }

    return React.createElement('a', { href: linkHref, target: '_blank' }, message)
}

export const helpContactLink = (locationCode = "") => {
    let linkHref = 'https://www.vu.edu.au/course-unit-advice';
    let message =  'contact your Course and Unit Advisor';

    if (getAttributeCourseStaticInfo('locationCd') === "SY") {
        linkHref = 'https://www.vu.edu.au/vu-sydney/contact-vu-sydney';
        message =  'contact your Course Coordinator';
    }

    return React.createElement('a', { href: linkHref, target: '_blank' }, message)
}

export const vuMainUnitLink = (unitCode = "", linkText, className = "") => {
    let linkHref = `https://www.vu.edu.au/units/${unitCode}`;

    return React.createElement('a', { href: linkHref, target: '_blank', className: className }, linkText)
}

export const helpVuCourseLink = (courseCode = "", courseLinkText = "", className = "") => {
    let linkHref = `https://www.vu.edu.au/courses/${courseCode}`;

    return React.createElement('a', { href: linkHref, target: '_blank', className: className }, courseLinkText)
}